import React, { useState } from 'react';
import { useAuth } from '../../services/auth/AuthContext';

const RefreshWarningBanner = () => {
    const { isLoggedIn } = useAuth();
    const [dismissed, setDismissed] = useState(false);

    if (!isLoggedIn || dismissed) return null;

    return (
        <div className="bg-danger bg-opacity-10 text-danger p-2 flex justify-between items-center">
            <p>
                <span className="font-bold">⚠️ Attention:</span> Actualiser cette page vous déconnectera. Utilisez la navigation du site pour naviguer.
            </p>
            <button
                onClick={() => setDismissed(true)}
                className="text-danger font-bold hover:text-opacity-80"
            >
                ✕
            </button>
        </div>
    );
};

export default RefreshWarningBanner;